<template>
  <div class="share-dialog common-dialog subscribe-dialog">
    <button class="close" @click="close">
      <icon-close></icon-close>
    </button>
    <div class="row no-gutters share-content">
      <div class="list" v-for="podcastApp in listPodcastApps" :key="podcastApp.name">
        <a class="app-item" :href="podcastApp.link" target="_blank">
          <img :src="podcastApp.image"/>
          <span>{{podcastApp.name}}</span>
        </a>
      </div>
      <a class="more list" :href="rssPageLink" v-if="showMoreAppsBtn" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        <span>More Apps</span>
      </a>
    </div>
  </div>
</template>
<script>
import IconClose from "./icons/IconClose";
import { mapState } from "vuex";
import {MUTATION_UPDATE} from "@/store/mutations";
export default {
  name: "PodcastAppsDialog",
  components: {IconClose},
  computed: {
    ...mapState(["podcastApps","rssPageLink"]),
    listPodcastApps() {
      return this.podcastApps.slice(0,5);
    },
    showMoreAppsBtn() {
      return this.podcastApps.length > 5;
    },
  },
  methods: {
    close() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", false]);
      this.$emit('hide');
    },
  }
}
</script>

<style scoped lang="scss">
.share-dialog {
  position: absolute;
  top: 0;
  background: #f6f6f6;
  width: 100%;
  height: 100%;
  z-index: 9999;
  right: 0;
  left: 0;
  .share-content{
    height: 105px;
  }
  .close{
    color: #f8f8f8;
    &:hover{
      opacity: 0.8;
    }
    &:focus{
      opacity: 0.8;
      outline: -webkit-focus-ring-color auto 1px;
    }
  }
  .share-content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    padding: 10px 25px;
    flex-direction: row !important;
  }
  a{
    &:hover{
      text-decoration: none;
      opacity: 0.7;
    }
  }
  .list{
    width: 50%;
    margin-bottom: 12px;
    .app-item{
      display: flex;
      line-height: 1;
      align-items: center;
    }
    img{
      width: 20px;
      margin-right: 10px;
      align-self: baseline;
    }
    span{
       color: #1a1a1a;
       font-size: 12px;
    }
  }
  .more{
    svg{
      position: relative;
      left: -3px;
      top: -1px;
      color: #1a1a1a;
      margin-right: 6px;
    }
    span{
       color: #1a1a1a;
    }
  }
}
@media (max-width: 599px) {
   .share-dialog {
     .share-content{
       padding: 10px 20px;
     }
   }
}
@media (max-width: 375px) {
   .share-dialog {
     .share-content{
       height: 88px;
     }
     .list{
       width: 33%;
       text-align: center;
       img{
         width: 28px;
       }
       .app-item{
         justify-content: center;
       }
       span{
        display: none;
       }
     }
   }
}
</style>

